import { render, staticRenderFns } from "./AssessmentWeeksItem.vue?vue&type=template&id=3402bc4a&scoped=true&"
import script from "./AssessmentWeeksItem.vue?vue&type=script&lang=js&"
export * from "./AssessmentWeeksItem.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentWeeksItem.vue?vue&type=style&index=0&id=3402bc4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3402bc4a",
  null
  
)

export default component.exports